import { render, staticRenderFns } from "./UserBillingPlans.vue?vue&type=template&id=3c0901ef&"
import script from "./UserBillingPlans.vue?vue&type=script&lang=js&"
export * from "./UserBillingPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports